import { filter, find } from 'lodash-es';
import { DOMElementSpec } from './schemas';
import type { OpenAPIV3 } from 'openapi-types';

import { ErrorModalOptions } from './modal';

interface Transformer<O> {
  (option: O): O;
}

function hook<T extends Transformer<TO>, TO>() {
  const hooks: T[] = [];

  const f = function (opts: TO) {
    for (let fn of hooks) {
      opts = fn(opts);
    }
    return opts;
  };
  f.add = function (fn: T) {
    hooks.push(fn);
    return fn;
  };
  return f;
}

interface ErrorModalOptionsTransformer extends Transformer<ErrorModalOptions> {}

interface ErrorModalOptionsHook extends ErrorModalOptionsTransformer {
  add(fn: ErrorModalOptionsTransformer): void;
}

const errorModalOptionsHook: ErrorModalOptionsHook = hook<
  ErrorModalOptionsTransformer,
  ErrorModalOptions
>();

interface BuildContext {
  spec: DOMElementSpec;
  schemas?: Dictionary<OpenAPIV3.Document>;
}

type ComponentBuildCallback = (ctx: BuildContext) => void;

const REGISTRY: {
  tagName: string;
  callback: ComponentBuildCallback;
}[] = [];

function onDomNodePrebuild(tagName: string, fn: ComponentBuildCallback) {
  REGISTRY.push({ tagName, callback: fn });
}

function domNodePrebuild(context: BuildContext) {
  for (const { callback } of filter(REGISTRY, {
    tagName: context.spec.tagName,
  })) {
    callback(context);
  }
}

function getOnComponentBuildHook(tagName: string) {
  const item = find(REGISTRY, { tagName });

  return item ? item.callback : null;
}

export const hooks = {
  onDomNodePrebuild,
  domNodePrebuild,
  errorModalOptionsHook,
};
